import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import reducers from '../reducers';

const middlewares = [];
middlewares.push(thunkMiddleware);

export default createStore(reducers, applyMiddleware(...middlewares));
